export enum CompetitorViewContext {
    PUBLIC,           // Anonymous/public users
    COMPETITOR_SELF,  // The competitor viewing their own data
    ADMINISTRATION,   // Admin users
    LEAGUE_ORGANISER
}
